import httpClient from "../../services/httpClient";

export const obtenerNoticiasEventos = () => {

    return new Promise( (resolve, eject) => {

        httpClient.get('https://www.pjecz.gob.mx/json/comunicados-noticias.json')
        .then( response => {
            if( response.status === 200 ){
                resolve( response );
            }
        })
        .catch( (error) => {
            resolve( error.response );
        });

    });

}